"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var portalPopoverBaseTheme = function (_breakpoints) { return ({
    portalPopoverWrapper: {
        display: "flex"
    },
    portalPopover: {},
    portalPopoverTrigger: {},
    portalPopoverLabel: {
        display: 'flex',
        alignContent: 'center',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        textTransform: 'none',
    },
}); };
exports.default = portalPopoverBaseTheme;
//# sourceMappingURL=portalPopover.js.map